import { render, staticRenderFns } from "./AffiliateDashboard.vue?vue&type=template&id=480fc74d"
import script from "./AffiliateDashboard.vue?vue&type=script&lang=js"
export * from "./AffiliateDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports